import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Instagram, Twitter } from "lucide-react";
export default function FooterInformation() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="24604" id="connect-legal" className="bg-background border-t border-border/40 py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          {}
          <nav className="flex flex-wrap justify-center md:justify-start gap-x-6 gap-y-2">
            <Link to="/HomePage" className="text-[14px] font-semibold text-foreground/80 hover:text-[#ff1a1a] transition-colors">
              Home
            </Link>
            <Link to="#" className="text-[14px] font-semibold text-foreground/80 hover:text-[#ff1a1a] transition-colors">
              Services
            </Link>
            <Link to="#" className="text-[14px] font-semibold text-foreground/80 hover:text-[#ff1a1a] transition-colors">
              Privacy
            </Link>
            <Link to="#" className="text-[14px] font-semibold text-foreground/80 hover:text-[#ff1a1a] transition-colors">
              Terms
            </Link>
          </nav>

          {}
          <div className="flex justify-center gap-2">
            <Button variant="ghost" size="icon" className="h-8 w-8 rounded-[4px] text-[#ff1a1a] hover:text-[#ff1a1a]/80 hover:bg-primary/10 transition-all" asChild>
              <Link to="#" aria-label="Twitter">
                <Twitter className="h-4 w-4" />
              </Link>
            </Button>
            <Button variant="ghost" size="icon" className="h-8 w-8 rounded-[4px] text-[#ff1a1a] hover:text-[#ff1a1a]/80 hover:bg-primary/10 transition-all" asChild>
              <Link to="#" aria-label="Instagram">
                <Instagram className="h-4 w-4" />
              </Link>
            </Button>
          </div>

          {}
          <div className="flex flex-col items-center md:items-end gap-1 text-[12px] text-foreground/60">
            <p>&copy; {currentYear} MigratePro. All rights reserved.</p>
            <p className="opacity-80 font-medium">Precision in Web Development</p>
          </div>
        </div>
      </div>
    </section>;
}